import React from 'react';
import { useSelector } from 'react-redux';
import MainCompo from '../Components/HomeComponents/MainCompo';
import SideBar from '../Components/HomeComponents/SideBar';
import Layout from '../Components/Layout/Layout';

const Home = () => {

    return (
        <Layout>
            <MainCompo></MainCompo>
        </Layout>
    );
};

export default Home;